import { render, staticRenderFns } from "./startTrain.vue?vue&type=template&id=39ded72b&scoped=true"
import script from "./startTrain.vue?vue&type=script&lang=js"
export * from "./startTrain.vue?vue&type=script&lang=js"
import style0 from "./startTrain.vue?vue&type=style&index=0&id=39ded72b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ded72b",
  null
  
)

export default component.exports